/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as EnvironmentalBenefitService} from "../../../Services/EnvironmentalBenefitService";

export class EnvironmentalBenefitFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			environmentalBenefits: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		EnvironmentalBenefitService.Get()
			.then((x) => {
				this.setState({environmentalBenefits: x.result});
			});
	}

	@autobind
	getEnvironmentalBenefit() {
		return this.state.environmentalBenefits.find((x) => x.environmentalBenefitId == this.props.Value);
	}

	@autobind
	_render() {
		return this.getEnvironmentalBenefit() ? this.getEnvironmentalBenefit().name : "N/A";
	}
}